import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

export const transferManagementBaseUrl = `/transfers`;

const transferManagementIcon = generateImage({
  noScale: true,
  name: 'transfer',
  alt: 'transfer',
  className: 'w-4 h-4',
});

const getTransferManagementRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.TRANSFER_MODULE,
      route: transferManagementBaseUrl,
      title: ScreenNames.TRANSFER_MODULE,
      icon: transferManagementIcon,
      component: null,
      children: [
        {
          id: ModuleConstants.TRANSFER_REQUESTS_TRACKER,
          route: `${transferManagementBaseUrl}/requests`,
          title: ScreenNames.TRANSFER_REQUESTS_TRACKER,
          component: ComponentsMap.TRANSFER_REQUESTS_TRACKER,
          children: [
            {
              id: ModuleConstants.TRANSFER_REQUESTS_TRACKER_DETAILS,
              route: `${transferManagementBaseUrl}/requests/:type/:id`,
              title: ScreenNames.TRANSFER_REQUESTS_TRACKER_DETAILS,
              component: ComponentsMap.TRANSFER_REQUESTS_TRACKER_DETAILS,
              sidebarVisibility: false,
            },
            {
              id: ModuleConstants.TRANSFER_REQUESTS_TRACKER_DETAILS,
              route: `${transferManagementBaseUrl}/requests/:type`,
              title: ScreenNames.TRANSFER_REQUESTS_TRACKER_DETAILS,
              component: null,
              sidebarVisibility: false,
            },
          ],
        },
        {
          id: ModuleConstants.TRANSFER_EMPLOYEE_HISTORY,
          route: `${transferManagementBaseUrl}/employees`,
          title: ScreenNames.TRANSFER_EMPLOYEE_HISTORY,
          component: ComponentsMap.TRANSFER_EMPLOYEE_HISTORY,
        },
      ],
    },
  ];
};

export default getTransferManagementRoutes;
